import * as React from "react"
import { CascaderAjaxSeeker, IconSeekers } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { getSection } from "app/utils"
import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL, FEATURES } from 'app/@common/constants'


export default function SelectRawRooms({ ...props }) {

    const section = getSection(window.location.href)

    if (!props.date || (section === FEATURES.COMPETITION && !props.sites) || !props.occupancy || !props.nights) return <SelectLoading />
    if (section === 'packages' && (!props.selectedRoute?.length || !props.sitePackageID.length)) return <SelectLoading />
    
    return <CascaderAjaxSeeker
		urlAjax={COMPETITION_URL.ROOMS}
        filters={{
            boardID: props.board,
            id_rate: props.rate,
            dateRange: props.date,
            nights: props.nights, 
            occupancy: props.occupancy, 
            devices: props.devices,
            hotelID: props.hotels,
            info: props.info,
            siteID: props.sites,
            ...getSection(window.location.href) === 'competition' && !props.sites && { id_site: props.sites },
            ...props.selectedRoute?.length && { routes: props.selectedRoute },
            ...props.sitePackageID?.length ? { sitePackageID: props.sitePackageID } : { id_site: props.sites },
            ...props.refresh && { refresh_cache: props.refresh },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...'id_main_hotel' in props && { id_main_hotel: props.id_main_hotel },
            ...props.date === 'custom' && {
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            }
        }}
        className="cascader-rooms"
		label=""
        method='POST'
		placeholder={<>
            <IconSeekers icon="bed" iconType="fontAwesome" style={{ color: 'var(--primary)' }} />
            <span style={{ marginLeft: '10px' }}>All room types</span>
        </>}
        menuWidth={350}
        container={() => document.body}
        preventOverflow
		{...props}
	/>
}